"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logging = void 0;
var Logging;
(function (Logging) {
    var Services;
    (function (Services) {
        Services["APP"] = "app";
        Services["DAWN"] = "dawn";
        Services["INDI"] = "indi";
        Services["WIDGETS"] = "widgets";
    })(Services = Logging.Services || (Logging.Services = {}));
    var Screens;
    (function (Screens) {
        Screens["COMMON"] = "common";
        Screens["MAIN"] = "main";
        Screens["MENU"] = "menu";
        Screens["CONSULTATIONS"] = "consultations";
        Screens["PRODUCTS"] = "products";
        Screens["MY_DAY"] = "myDay";
    })(Screens = Logging.Screens || (Logging.Screens = {}));
})(Logging = exports.Logging || (exports.Logging = {}));
